type ChipType = {
  id: string;
  name: string;
};

const checkFieldsKeys = (item: unknown): item is ChipType => {
  return !!item && typeof item === 'object' && 'id' in item && 'name' in item;
};

export const getChipData = (data: unknown, fieldName: string): ChipType[] => {
  if (!data || typeof data !== 'object' || !(fieldName in data)) return [];

  const chips = (data as Record<string, unknown>)[fieldName];

  if (Array.isArray(chips) && chips.every(checkFieldsKeys)) {
    return chips as ChipType[];
  }

  return [];
};

export const getSelectedItems = (
  value: ChipType | ChipType[] | null,
  multiple: boolean
): ChipType[] => {
  if (multiple) {
    return Array.isArray(value) ? value : [];
  }
  return value ? [value as ChipType] : [];
};
